module.exports = __webpack_public_path__ + "static/media/Item_Weapon_M9_C.3e92e81a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Handgun/Item_Weapon_M9_C.png
// module id = ./src/assets/item/Weapon/Handgun/Item_Weapon_M9_C.png
// module chunks = 0